/**
 * ProjectManager — modal for listing, creating, and selecting projects.
 */
export class ProjectManager {
    constructor(container, options = {}) {
        this._container = container;
        this._onSelect = options.onSelect || (() => {});
        this._projectStore = options.projectStore;
        this._el = null;
    }

    show() {
        this._render();
    }

    hide() {
        if (this._el) {
            this._el.remove();
            this._el = null;
        }
    }

    _render() {
        this.hide();
        const projects = this._projectStore.getAll();

        this._el = document.createElement('div');
        this._el.className = 'rm-project-modal';
        this._el.innerHTML = `
            <div class="rm-project-modal-content">
                <h2>Resume Projects</h2>
                <div class="rm-project-list">
                    ${projects.length === 0
                        ? '<div class="rm-empty-state"><div>No projects yet</div></div>'
                        : projects.map(p => `
                            <div class="rm-project-item" data-id="${p.id}">
                                <div>
                                    <div class="rm-project-item-name">${this._esc(p.name)}</div>
                                    <div class="rm-project-item-meta">${p.description || 'No description'}</div>
                                </div>
                                <button class="rm-btn rm-btn-danger rm-project-delete" data-id="${p.id}" title="Delete">&times;</button>
                            </div>
                        `).join('')
                    }
                </div>
                <div class="rm-project-actions">
                    <button class="rm-btn" id="rmProjectCancel">Cancel</button>
                    <button class="rm-btn rm-btn-primary" id="rmProjectNew">New Project</button>
                </div>
            </div>
        `;

        // Event handlers
        this._el.querySelector('#rmProjectCancel').addEventListener('click', () => this.hide());
        this._el.querySelector('#rmProjectNew').addEventListener('click', () => this._showCreateForm());

        // Click project to select
        for (const item of this._el.querySelectorAll('.rm-project-item')) {
            item.addEventListener('click', (e) => {
                if (e.target.classList.contains('rm-project-delete')) return;
                this._onSelect(item.dataset.id);
                this.hide();
            });
        }

        // Delete buttons
        for (const btn of this._el.querySelectorAll('.rm-project-delete')) {
            btn.addEventListener('click', async (e) => {
                e.stopPropagation();
                if (confirm('Delete this project and all its candidates?')) {
                    await this._projectStore.remove(btn.dataset.id);
                    this._render();
                }
            });
        }

        // Click backdrop to close
        this._el.addEventListener('click', (e) => {
            if (e.target === this._el) this.hide();
        });

        this._container.appendChild(this._el);
    }

    _showCreateForm() {
        const content = this._el.querySelector('.rm-project-modal-content');
        content.innerHTML = `
            <h2>New Project</h2>
            <div class="rm-form-row">
                <label class="rm-prompt-form label">Name</label>
                <input type="text" id="rmNewName" placeholder="e.g. Senior EE Hire 2026" style="background:var(--bg-secondary);color:var(--text);border:1px solid var(--border);border-radius:6px;padding:8px 12px;font-size:14px;">
            </div>
            <div class="rm-form-row" style="margin-top:12px">
                <label class="rm-prompt-form label">Description</label>
                <input type="text" id="rmNewDesc" placeholder="Optional description" style="background:var(--bg-secondary);color:var(--text);border:1px solid var(--border);border-radius:6px;padding:8px 12px;font-size:14px;">
            </div>
            <div class="rm-project-actions" style="margin-top:16px">
                <button class="rm-btn" id="rmCreateCancel">Cancel</button>
                <button class="rm-btn rm-btn-primary" id="rmCreateSave">Create</button>
            </div>
        `;

        content.querySelector('#rmCreateCancel').addEventListener('click', () => this._render());
        content.querySelector('#rmCreateSave').addEventListener('click', async () => {
            const name = content.querySelector('#rmNewName').value.trim();
            if (!name) return;
            const desc = content.querySelector('#rmNewDesc').value.trim();
            const id = await this._projectStore.create(name, desc, 'user');
            this._onSelect(id);
            this.hide();
        });

        content.querySelector('#rmNewName').focus();
    }

    _esc(str) {
        const d = document.createElement('div');
        d.textContent = str || '';
        return d.innerHTML;
    }
}
